import { render, staticRenderFns } from "./OBanner.vue?vue&type=template&id=7b82d880"
import script from "./OBanner.vue?vue&type=script&lang=js"
export * from "./OBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports